import React, { Component } from 'react';

class NoMatch extends Component{
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                Error 404: Page not found
            </div>
        );
    }
}

export default NoMatch;
